import React, { useState } from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";

import { MAX_FILE_SIZE, IMAGES_FORMATS } from "../../constants/constants";

import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";

import ICTempImg from "../../assets/images/noimg.png";
import ICCheckbox from "../../components/form/checkbox";
import { BANNER_TYPE_CONSULT_DETAILS } from "../../constants/helperConstants";

const ConsultNatureForm = props => {
  const [fileError, setFileError] = useState("");

  // validate input file
  const validateFile = file => {
    setFileError("");
    if (file) {
      if (file.size >= MAX_FILE_SIZE) {
        setFileError("Maximum 2MB file is allowed");
        return false;
      } else if (!IMAGES_FORMATS.includes(file.type)) {
        setFileError(
          "File must be one of these formats only jpg, jpeg, png, svg"
        );
        return false;
      }
    }
    return true;
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      consultTitle: props.consult !== null ? props.consult.content : "",
      consultPicture: null,
      previewImg: props.consult !== null ? props.consult.consultPic : ICTempImg,
      description: props.consult !== null ? props.consult.description : "",
      isNew: props.consult !== null && props.consult.bannerType ? props.consult.bannerType == "NEW" : false,
      isRedirect: props.consult !== null && props.consult.isRedirect ? props.consult.isRedirect : false,
      redirectURL: props.consult !== null && props.consult.redirectURL ? props.consult.redirectURL : '',
    },
    validationSchema: Yup.object({
      consultTitle: Yup.string()
        .min(2, "Consult title must be of minimum length 2")
        .required("Please enter Consult Title"),
      isRedirect: Yup.boolean(),
      redirectURL: Yup.string().url()
        .when("isRedirect", {
          is: true,
          then: Yup.string().required("Please enter correct URL"),
        })
    }),
    onSubmit: values => {
      let formData = new FormData();
      formData.append("consultName", values.consultTitle);
      formData.append("description", values.description);
      formData.append(
        "consultPic",
        values.consultPicture !== null
          ? values.consultPicture
          : values.previewImg
      );
      formData.append("isFile", values.consultPicture !== null ? true : false);

      if (values.isNew == true) {
        formData.append("bannerType", BANNER_TYPE_CONSULT_DETAILS.NEW);
      }

      formData.append("isRedirect", values.isRedirect);
      formData.append("redirectURL", values.redirectURL);

      // if the form is in update state
      if (props.consult !== null) {
        formData.append("consultId", props.consult._id);
        props.onEditSubmit(formData);
        formik.resetForm();
      }
      // if the form is in add state
      else if (props.consult === null && values.consultPicture !== null) {
        props.onAddSubmit(formData);
        formik.resetForm();
      }
      // throw image upload error
      else {
        setFileError("Please upload consult image");
      }
    }
  });

  return (
    <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            Consult Title <span className="error">*</span>
          </label>
          <ICInput
            name="consultTitle"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.consultTitle}
            error={
              formik.touched.consultTitle && formik.errors.consultTitle
                ? true
                : false
            }
            helperText={
              formik.touched.consultTitle && formik.errors.consultTitle
                ? formik.errors.consultTitle
                : ""
            }
          />
        </div>
        <div className="form-group col-md-6">
          <label>
            Consult Image <span className="error">*</span>
          </label>
          <div className="d-flex flex-row">
            <img
              className="rounded-circle user-img mr-2"
              src={
                formik.values.previewImg !== ""
                  ? formik.values.previewImg
                  : ICTempImg
              }
              alt="consult-img"
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3"
                type="file"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0])) {
                    formik.setFieldValue(
                      "consultPicture",
                      event.currentTarget.files[0]
                    );

                    formik.setFieldValue(
                      "previewImg",
                      URL.createObjectURL(event.currentTarget.files[0])
                    );
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                JPG, SVG or PNG. Max size of 2MB
              </span>
              <br />
              <Error class="error">{fileError}</Error>
            </p>
          </div>
        </div>
        <div className="form-group col-md-12">
          <label>
            Description
          </label>
          <TextField
            name="description"
            className="w-100 dynamic-textarea"
            multiline
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>

        <div className="form-group col-sm-12">
          <ICCheckbox
            className="ml-2 primary-color-chk"
            name="isNew"
            label="New"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.isNew}
            checked={formik.values.isNew}
            inputProps={{ "aria-label": "primary checkbox" }}
          />

        </div>

        <div className="form-group col-sm-12">
          <label className="">
            Redirect To:
          </label>

          <ICCheckbox
            className="ml-2 primary-color-chk"
            name="isRedirect"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.isRedirect}
            checked={formik.values.isRedirect}
            inputProps={{ "aria-label": "primary checkbox" }}
          />

        </div>

        {
          formik.values.isRedirect && (

            <div className="form-group col-sm-12">
              <label>
                URL
              </label>
              <TextField
                name="redirectURL"
                className="w-100 dynamic-textarea"
                value={formik.values.redirectURL}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.redirectURL && formik.errors.redirectURL
                    ? true
                    : false
                }
                helperText={
                  formik.touched.redirectURL && formik.errors.redirectURL
                    ? formik.errors.redirectURL
                    : ""
                }
              />
            </div>
          )
        }
      </div>
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button
          title={props.consult !== null ? "Update" : "Save"}
          type="submit"
        />
      </p>
    </form>
  );
};

export default ConsultNatureForm;

ConsultNatureForm.defaultProps = {
  consult: null,
  onAddSubmit: () => {},
  onEditSubmit: () => {}
};

ConsultNatureForm.propTypes = {
  consult: PropTypes.object,
  onAddSubmit: PropTypes.func,
  onEditSubmit: PropTypes.func
};
